// extracted by mini-css-extract-plugin
export default {"closeButton":"_3CCpY_X-TPAarRXnROaOaz"};